package br.com.vvrefeicoes.portal.feature.orgchart

import br.com.vvrefeicoes.portal.domain.model.Company

/**
 * Agrupa itens que compartilham exatamente o mesmo conjunto (não vazio) de unidades.
 * A ordem do primeiro item de cada grupo é preservada. Itens sem unidades não são agrupados.
 */
internal fun <T> groupByCompanySet(
    items: List<T>,
    companies: (T) -> List<Company>,
): List<List<T>> {
    val grouped =
        items
            .filter { companies(it).isNotEmpty() }
            .groupBy { item -> companies(item).map { it.id }.sorted().joinToString(",") }
    val seen = mutableSetOf<String>()
    val result = mutableListOf<List<T>>()
    items.forEach { item ->
        val itemCompanies = companies(item)
        if (itemCompanies.isEmpty()) {
            result += listOf(item)
        } else {
            val key = itemCompanies.map { it.id }.sorted().joinToString(",")
            if (seen.add(key)) {
                result += grouped.getValue(key)
            }
        }
    }
    return result
}
